// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Theme from "./Theme.bs.js";
import * as Emotion from "../bindings/Emotion.bs.js";

function injectGlobalStyles() {
  Emotion.Css.injectGlobal(`
    *, *::before, *::after {
      box-sizing: border-box;
    }

    * {
      margin: 0;
    }

    html {
      scroll-behavior: smooth;
    }

    body {
      font-family: ` + Theme.Theme.Typography.fontFamily.sans + `;
      font-size: ` + Theme.Theme.Typography.fontSize.base + `;
      font-weight: 400;
      line-height: ` + Theme.Theme.Typography.lineHeight.normal + `;
      color: ` + Theme.Theme.Colors.text.primary + `;
      background-color: ` + Theme.Theme.Colors.background.primary + `;
      min-height: 100vh;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    h1, h2, h3, h4, h5, h6 {
      font-family: ` + Theme.Theme.Typography.fontFamily.serif + `;
      color: ` + Theme.Theme.Colors.text.primary + `;
      font-weight: 400;
      line-height: 1.2;
      letter-spacing: -0.02em;
      margin-bottom: 1rem;
    }

    h1 { font-size: 2.5rem; }
    h2 { font-size: 2rem; }
    h3 { font-size: 1.5rem; }
    h4 { font-size: 1.25rem; }
    h5 { font-size: 1.125rem; }
    h6 { font-size: 1rem; }

    p {
      margin-bottom: 1rem;
      color: ` + Theme.Theme.Colors.text.primary + `;
    }

    a {
      color: ` + Theme.Theme.Colors.brand.primary + `;
      text-decoration: none;
      font-weight: 500;
      transition: color ` + Theme.Theme.Animations.duration.fast + ` ` + Theme.Theme.Animations.easing["ease-out"] + `;
    }

    a:hover {
      color: ` + Theme.Theme.Colors.brand["primary-light"] + `;
      text-decoration: underline;
      text-underline-offset: 3px;
    }

    a:focus {
      outline: none;
      box-shadow: ` + Theme.Theme.Shadows.colored.primary + `;
      border-radius: ` + Theme.Theme.Borders.radius.sm + `;
    }

    code {
      font-family: ` + Theme.Theme.Typography.fontFamily.mono + `;
      font-size: 0.875em;
      background-color: ` + Theme.Theme.Colors.background.elevated + `;
      padding: 0.25rem 0.5rem;
      border-radius: ` + Theme.Theme.Borders.radius.sm + `;
      border: 1px solid ` + Theme.Theme.Colors.border.default + `;
    }

    pre {
      font-family: ` + Theme.Theme.Typography.fontFamily.mono + `;
      background-color: ` + Theme.Theme.Colors.background.elevated + `;
      padding: 1rem;
      border-radius: ` + Theme.Theme.Borders.radius.md + `;
      border: 1px solid ` + Theme.Theme.Colors.border.default + `;
      overflow-x: auto;
      margin-bottom: 1rem;
    }

    pre code {
      background: none;
      padding: 0;
      border: none;
    }

    input, textarea, select, button {
      font-family: inherit;
      font-size: inherit;
    }

    button {
      cursor: pointer;
      border: none;
      background: none;
      padding: 0;
    }

    input, textarea, select {
      background-color: ` + Theme.Theme.Colors.background.secondary + `;
      border: 1px solid ` + Theme.Theme.Colors.border.default + `;
      border-radius: ` + Theme.Theme.Borders.radius.md + `;
      padding: 0.5rem 0.75rem;
      color: ` + Theme.Theme.Colors.text.primary + `;
      transition: all ` + Theme.Theme.Animations.duration.fast + ` ` + Theme.Theme.Animations.easing["ease-out"] + `;
    }

    input:focus, textarea:focus, select:focus {
      outline: none;
      border-color: ` + Theme.Theme.Colors.brand.primary + `;
      box-shadow: ` + Theme.Theme.Shadows.colored.primary + `;
    }

    input::placeholder, textarea::placeholder {
      color: ` + Theme.Theme.Colors.placeholder + `;
    }

    .sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border: 0;
    }

    @keyframes spin {
      to { transform: rotate(360deg); }
    }

    @media (prefers-reduced-motion: reduce) {
      *, *::before, *::after {
        animation-duration: 0.01ms !important;
        animation-iteration-count: 1 !important;
        transition-duration: 0.01ms !important;
        scroll-behavior: auto !important;
      }
    }
  `);
}

let initialize = injectGlobalStyles;

export {
  injectGlobalStyles,
  initialize,
}
/* Theme Not a pure module */
